import {
  faCircleCheck,
  faPauseCircle,
  faQuestionCircle,
  faTimesCircle,
  IconDefinition
} from '@fortawesome/free-solid-svg-icons';

import { TREATABILITY_STATUS } from '@/constants/treatability';
import { InsurancePolicy } from '@/types/insurancePolicy';
import { dateFromDateStringWithAppendedTime } from '@/utils/dates';

type IconAndColor = {
  icon: IconDefinition;
  color: string;
};

const iconAndColorMap: Record<TREATABILITY_STATUS, IconAndColor> = {
  [TREATABILITY_STATUS.WAITLISTED]: { icon: faPauseCircle, color: 'text-yellow-500' },
  [TREATABILITY_STATUS.TREATABLE]: { icon: faCircleCheck, color: 'text-green-500' },
  [TREATABILITY_STATUS.NOT_TREATABLE]: { icon: faTimesCircle, color: 'text-red-500' },
  [TREATABILITY_STATUS.UNKNOWN]: { icon: faQuestionCircle, color: 'text-yellow-500' }
};

export const getInsuranceIconAndColor = (
  treatabilityStatus: Pick<InsurancePolicy, 'treatability_status'>['treatability_status'],
  planEndDateStr: Pick<InsurancePolicy, 'plan_end_date'>['plan_end_date']
): IconAndColor => {
  const planEndDate = planEndDateStr ? dateFromDateStringWithAppendedTime(planEndDateStr) : null;
  const isPlanExpired = planEndDate && planEndDate < new Date();

  return isPlanExpired
    ? iconAndColorMap[TREATABILITY_STATUS.NOT_TREATABLE]
    : iconAndColorMap[treatabilityStatus || TREATABILITY_STATUS.UNKNOWN];
};
